var $f398debcce5a5c55$exports = {};
$f398debcce5a5c55$exports = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};


export {$f398debcce5a5c55$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
